import { render, staticRenderFns } from "./linkagecenter1.vue?vue&type=template&id=77fbfc87"
import script from "./linkagecenter1.vue?vue&type=script&lang=js"
export * from "./linkagecenter1.vue?vue&type=script&lang=js"
import style0 from "./linkagecenter1.vue?vue&type=style&index=0&id=77fbfc87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports